<div class="breadcrumb__container">
  <ul class="breadcrumb__list">
    <ng-container>
      <li
        *ngFor="let crumb of trail; let i = index; trackBy: identify"
        [ngClass]="
          isStaff
            ? 'breadcrumb__list-bullet__staff'
            : 'breadcrumb__list-bullet__kids'
        "
      >
        <a [routerLink]="crumb.path" [queryParams]="getQueryParams(crumb, i)">
          <ng-container *ngIf="!isStaff; else staff">
            <div class="kinder-link__container">
              <img
                [src]="crumb.imageUrl"
                alt="{{ crumb.name }} Breadcrumb image"
              />
              <p class="kinder-link__caption">
                {{ crumb.name }}
              </p>
            </div>
          </ng-container>
          <ng-template #staff>{{ crumb.name }}</ng-template></a
        >
      </li>
    </ng-container>
  </ul>
</div>
